import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const SecondContactPersonSummaryFormIN = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({
    slideIds: ['contactPersons'],
  });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  //secondContactFirstname  secondContactLastname  secondContactRelationship  secondContactPhoneNumber  secondContactEmailAddress
  //secondContactFirstname
  const secondContactFirstnameField = s.contactPersons.fields.find(({ name }) => name === 'secondContactFirstname');
  const secondContactFirstnameLabel = translate(secondContactFirstnameField?.label);

  // secondContactLastname
  const secondContactLastnameField = s.contactPersons.fields.find(({ name }) => name === 'secondContactLastname');
  const secondContactLastnameLabel = translate(secondContactLastnameField?.label);

  // secondContactRelationship
  const secondContactRelationshipField = s.contactPersons.fields.find(
    ({ name }) => name === 'secondContactRelationship'
  );
  const secondContactRelationshipLabel = translate(secondContactRelationshipField?.label);

  // secondContactPhoneNumber
  const secondContactPhoneNumberField = s.contactPersons.fields.find(({ name }) => name === 'secondContactPhoneNumber');
  const secondContactPhoneNumberLabel = translate(secondContactPhoneNumberField?.label);

  // secondContactEmailAddress
  const secondContactEmailAddressField = s.contactPersons.fields.find(
    ({ name }) => name === 'secondContactEmailAddress'
  );
  const secondContactEmailAddressLabel = translate(secondContactEmailAddressField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-second-contact-person'}>
      <h2>{translate(s.dataSummary.titles?.secondContactPerson)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{secondContactFirstnameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('secondContactFirstname')}
          {editMode && <EditDataField field={secondContactFirstnameField!} slideId={'contactPersons'} />}
        </div>
        <div className={'label'}>{secondContactLastnameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('secondContactLastname')}
          {editMode && <EditDataField field={secondContactLastnameField!} slideId={'contactPersons'} />}
        </div>
        <div className={'label'}>{secondContactRelationshipLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('secondContactRelationship')}
          {editMode && <EditDataField field={secondContactRelationshipField!} slideId={'contactPersons'} />}
        </div>
        <div className={'label'}>{secondContactPhoneNumberLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('secondContactPhoneNumber')}
          {editMode && <EditDataField field={secondContactPhoneNumberField!} slideId={'contactPersons'} />}
        </div>
        <div className={'label'}>{secondContactEmailAddressLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('secondContactEmailAddress')}
          {editMode && <EditDataField field={secondContactEmailAddressField!} slideId={'contactPersons'} />}
        </div>
      </div>
    </div>
  );
};
